import React, { useCallback, useState } from 'react'
import { Button } from 'shared';
import "./create-note.form.scss"

export const CreateNoteForm = ({ onSubmit, onCancel, isBtnLoading }) => {

    const [text, setText] = useState("");
    const [isFieldChanged, setIsFieldChanged] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!text.trim()) return;
        onSubmit({text: text.trim()});
    }

    const CancelButton = useCallback(() => <Button buttonText={"Otkaži"} event={onCancel} />, [onCancel]);
    
    const ConfirmButton = useCallback(
        () => (
            <Button
                type="submit"
                isDisabled={text === ''}
                buttonText='Sačuvaj belešku'
                buttonColor={"green"}
                event={handleSubmit}
                spinnerColor={"light"}
                isLoading={isBtnLoading}
            />
        ),
        [handleSubmit, isBtnLoading, isFieldChanged]
    );

    return (
        <form className='form'>
            <div className='content'>
                <h2 className="create-new-note__title">Kreiranje beleške</h2>
                <textarea
                    className='note-input__textarea'
                    rows={5}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Unesite tekst beleške..."
                />
            </div>
            <div className="create-new-item__controls">
                <CancelButton />
                <ConfirmButton />
            </div>
        </form>    
    )
}